// src/services/clientConfigService.js
let config = null;

export const loadClientConfig = async () => {
  const clientCode = process.env.REACT_APP_CLIENT_CODE;
  const res = await fetch(`/config/${clientCode}-config.json`);
  config = await res.json();
  return config;
};

export const getClientConfig = () => config;
